export const BOOKING_TRACKING_SESSION_STORAGE_KEY = 'gh.bookingTrackingSession.v1'

/** @internal test hook */
let sessionIdOverride: string | null = null

function generateSessionId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `session-${Date.now()}-${Math.random().toString(16).slice(2)}`
}

/**
 * Stable per browser tab (sessionStorage survives reload; not shared across tabs).
 */
export function getBookingTrackingSessionId(): string {
  if (sessionIdOverride) {
    return sessionIdOverride
  }
  if (typeof sessionStorage === 'undefined') {
    return generateSessionId()
  }
  try {
    const existing = sessionStorage.getItem(BOOKING_TRACKING_SESSION_STORAGE_KEY)
    if (existing && existing.length > 0) {
      return existing
    }
    const created = generateSessionId()
    sessionStorage.setItem(BOOKING_TRACKING_SESSION_STORAGE_KEY, created)
    return created
  } catch {
    return generateSessionId()
  }
}

/** @internal test hook */
export function setBookingTrackingSessionIdForTests(sessionId: string | null): void {
  sessionIdOverride = sessionId
}

/** @internal test hook */
export function resetBookingTrackingSessionForTests(): void {
  sessionIdOverride = null
  if (typeof sessionStorage !== 'undefined') {
    try {
      sessionStorage.removeItem(BOOKING_TRACKING_SESSION_STORAGE_KEY)
    } catch {
      // ignore
    }
  }
}

export function bookingTrackingLocalStorageKey(sessionId: string): string {
  return `gh.bookingTracking.v1.${sessionId}`
}
